// removed by extract-text-webpack-plugin
module.exports = {"container":"_1QSEc _7mR3c","mainSection":"wonsV","inner":"_2DfhE","searchContainer":"_1-r4w","inventorySearch":"_11pQe","searchButton":"_1-XNk","searchLinks":"_2jw4p","searchLink":"_3NJ4N","active":"_1yVUB","header":"_3O2zs","subheader":"Xj2mz"};


//////////////////
// WEBPACK FOOTER
// ./banquet/containers/MarketingIndexContainer/index.sass
// module id = 1523
// module chunks = 1